import React, { useMemo } from 'react';
import { BuildingSummaryHealthStatus } from '../../../models/buildingModels';
import { OrganizationBuildingOverview } from '../../../models/organizationHealthModels';
import OrganizationHealthTable from '../../status/buildingsStatus/OrganizationHealthTable';
import PartnerBuildingRowContent from './PartnerBuildingRowContent';
import PartnerBuildingRowHeader from './PartnerBuildingRowHeader';

type Props = {
    offlineBuildings: BuildingSummaryHealthStatus[];
    darkHeader?: boolean;
    partnerManagedUserGroupId: string;
};

const transformToOrganizationBuildingOverview = (
    buildings: BuildingSummaryHealthStatus[]
): OrganizationBuildingOverview[] => {
    return buildings.map(building => ({
        locationId: building.locationId,
        locationName: building.locationName,
        hubStats: {
            total: building.hubs,
            offline: building.offlineHubs,
        },
        deviceStats: {
            total: building.sensorDevices,
            offline: building.offlineSensorDevices,
        },
    }));
};

const CustomerStatusBuildingsTable = ({ offlineBuildings, partnerManagedUserGroupId }: Props): React.ReactElement => {
    const organizationBuildings = useMemo(
        () => transformToOrganizationBuildingOverview(offlineBuildings),
        [offlineBuildings]
    );

    return (
        <OrganizationHealthTable
            organizationBuilding={organizationBuildings}
            isReady
            totalBuildings={offlineBuildings.length}
            tableId="partner_customer_buildings_table"
            renderHeader={(props): React.ReactElement => <PartnerBuildingRowHeader {...props} />}
            renderContent={(props): React.ReactElement | null => (
                <PartnerBuildingRowContent {...props} partnerManagedUserGroupId={partnerManagedUserGroupId} />
            )}
        />
    );
};

export default CustomerStatusBuildingsTable;
